import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadYooga: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"YOOGA"} title={"Importar catálogo Yooga"}
  instructions={"Copie a URL do cardápio digital da sua loja no Yooga."}
  placeholder={"https://delivery.yooga.app/sua-loja"} />;

export default UploadYooga;
